import React, { memo, useCallback, useState, useEffect } from 'react'
import { Divider, Paper } from '@material-ui/core'

import BannerHeadCard from '../BannerHeadCard'
import { CookiePolicyViewer } from './components'

import constants from 'constants/index'
import * as service from 'service'
import useSnackbar from 'hooks/useSnackbar'

const CookiePolicyCard = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [cookiePolicy, setCookiePolicy] = useState(null)
  const [isLoadingPolicy, setIsLoadingPolicy] = useState(true)
  const snackbar = useSnackbar()

  const loadCookiePolicy = useCallback(async () => {
    setIsLoadingPolicy(true)
    try {
      const response = await service.dponet.privacyPolicies.getCookiePolicy()
      const policies = response?.data?.privacyPolicies || []

      // Pega a primeira política de cookies ativa ou qualquer uma se não houver ativa
      const activePolicy = policies.find(
        (policy) => policy.status === constants.documents.ACTIVE_STATUS_ID,
      )
      const policyToShow = activePolicy || policies[0] || null

      setCookiePolicy(policyToShow)
    } catch (error) {
      console.error('Erro ao carregar política de cookies:', error)
      setCookiePolicy(null)
    } finally {
      setIsLoadingPolicy(false)
    }
  }, [])

  useEffect(() => {
    loadCookiePolicy()
  }, [loadCookiePolicy])

  const handleGenerateCookiePolicy = useCallback(async () => {
    if (isLoading) return

    setIsLoading(true)

    try {
      if (cookiePolicy?.id) {
        await service.dponet.privacyPolicies.updateCookiePolicy({
          cookiePolicyId: cookiePolicy.id,
        })
      } else {
        await service.dponet.privacyPolicies.createCookiePolicy()
      }

      snackbar.open({
        message: 'Política de Cookies gerada com sucesso!',
        variant: 'success',
      })

      await loadCookiePolicy()
    } catch (error) {
      snackbar.open({
        message: 'Erro ao gerar a Política de Cookies. Tente novamente.',
        variant: 'error',
      })
    } finally {
      setIsLoading(false)
    }
  }, [isLoading, snackbar, loadCookiePolicy, cookiePolicy?.id])

  return (
    <Paper
      variant="outlined"
      id={constants.cookies.banner.COOKIES_BANNER_SETTING_DRIVER_STEP_6}
    >
      <BannerHeadCard
        name="Política de Cookies"
        showDaiButton
        onDaiClick={handleGenerateCookiePolicy}
        isLoading={isLoading}
        hasExistingPolicy={!!cookiePolicy}
      />
      <Divider />

      <CookiePolicyViewer
        cookiePolicy={cookiePolicy}
        isLoading={isLoadingPolicy}
      />
    </Paper>
  )
}

export default memo(CookiePolicyCard)
